import Accordion from 'modules/accordion';

const moreButtons = document.querySelectorAll<HTMLElement>('[data-open-category]');
for (const moreButton of moreButtons) {
  moreButton.addEventListener('click', () => {
    const categoryId = moreButton.dataset.openCategory;
    const targetCategory = document.querySelector<HTMLElement>(`[data-category="${categoryId}"]`);
    const hiddenItems = targetCategory.querySelectorAll('.p-qa.is-hidden');
    for (const item of hiddenItems) {
      item.classList.remove('is-hidden');
    }
    moreButton.classList.add('is-hidden');
  });
}

const faqContainer = document.getElementById('js-faq-container');
const faqAccordion = new Accordion(faqContainer);
// よくある質問の開閉
faqAccordion.onClick();
